import { HttpResponse } from '@angular/common/http';

/*
 * Gemeinsame Hilfen für den Takeda-Abrechnungsexport (Projektansicht und
 * Excel-Exportdialog): Fehlertexte und das Speichern einer Blob-Antwort.
 *
 * Die Datei kommt über HttpClient, damit der AuthInterceptor den Bearer-Token
 * mitschickt – ein einfacher Link oder window.open() käme ohne Authorization an.
 */

/** Macht aus einem HTTP-Fehler eine Meldung, mit der man etwas anfangen kann. */
export function takedaExportFehlerText(err: any, standard: string): string {
  if (err?.error?.message) { return err.error.message; }

  if (err?.status === 404) {
    return 'Der Export-Endpunkt ist auf dem Server nicht vorhanden. '
      + 'Vermutlich läuft dort noch eine ältere Version – bitte das Backend neu starten.';
  }
  if (err?.status === 403) {
    return 'Für den Export fehlt die Berechtigung (Bauleiter oder Admin erforderlich).';
  }
  if (err?.status === 0) {
    return 'Der Server ist nicht erreichbar.';
  }

  return err?.status ? `${standard} (HTTP ${err.status})` : standard;
}

/** Dateiname aus Content-Disposition, damit Server und Download übereinstimmen. */
export function takedaDateinameAusHeader(response: HttpResponse<Blob>): string | null {
  const header = response.headers.get('content-disposition');
  if (!header) { return null; }

  const treffer = /filename\*?=(?:UTF-8'')?"?([^;"]+)"?/i.exec(header);
  return treffer ? decodeURIComponent(treffer[1]).trim() : null;
}

/**
 * Startet den Browser-Download einer Blob-Antwort.
 * Liefert false, wenn die Antwort keinen Inhalt hatte.
 */
export function speichereTakedaExportDatei(response: HttpResponse<Blob>, standardName: string): boolean {
  const blob = response.body;
  if (!blob) { return false; }

  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = takedaDateinameAusHeader(response) ?? standardName;
  link.click();

  // Der Browser braucht die URL nur bis zum Start des Downloads.
  setTimeout(() => URL.revokeObjectURL(url), 10000);
  return true;
}
